import camelCase from 'lodash/camelCase';
import upperFirst from 'lodash/upperFirst';
import Vue from 'vue';

/**
 * Registers base components
 *
 */
export default () => {
    // eslint-disable-next-line no-undef
    const requireComponent = require.context(
        '.',
        true,
        /Base[A-Z]\w+\.(vue|js)$/
    );

    requireComponent.keys().forEach(fileName => {
        const componentConfig = requireComponent(fileName);

        const componentName = upperFirst(
            camelCase(
                fileName
                    .split('/')
                    .pop()
                    .replace(/\.\w+$/, '')
            )
        );

        Vue.component(
            componentName,
            componentConfig.default || componentConfig
        );
    });
};

export { default as ProgressBar } from './ProgressBar';
export { default as RegisterForm } from './RegisterForm';
export { default as ShowModal } from './ShowModal';
export { default as WelcomeBox } from './WelcomeBox';
